import { trackProofEvent } from "./proof_events.js";

// One delegated listener also covers links inserted by Turbo navigation.
document.addEventListener("click", (event) => {
  const anchor = event.target.closest?.("a[href]");
  if (anchor) {
    const url = new URL(anchor.href, location.href);
    if (url.origin === location.origin && /\/contact\/$/.test(url.pathname)) {
      const offers = { "ai-audit": "audit", "ai-integration": "integration", "ai-training": "training", "custom-software-brittany": "custom-software" };
      trackProofEvent("contact_cta", offers[url.searchParams.get("ref")] || "other");
    }
  }
  const link = event.target.closest?.("[data-simple-event]");
  const name = link?.dataset.simpleEvent;
  if (!name || !/^[a-z0-9_]{1,100}$/.test(name)) return;
  try {
    window.sa_event?.(name);
  } catch {
    // Measurement must never interrupt navigation or form submission.
  }
});
